import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EmployeeService } from '../../services/employee.service';
import { Employee } from '../../interfaces/client-data';
import { ToastService } from '../../services/toast.service';
import { ImpersonationService } from '../../services/impersonation.service';
import { Router } from '@angular/router';
import { UserManagementService } from '../../services/user-management.service';
import { CurrentUserStateService } from '../../services/current-user-state.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-impersonate-dialog',
    templateUrl: './impersonate-dialog.component.html',
    styleUrls: ['./impersonate-dialog.component.scss'],
})
export class ImpersonateDialogComponent implements OnInit {
    data: Employee[];
    visibleData: Employee[];

    selectedUser: any = null;
    savingUserChange = false;

    positionFilter = 'All';
    roleFilter = 'All';
    permissionFilter = 'All';

    positionFilters = [{ label: 'All', value: 'All' }];

    roleFilters = [{ label: 'All', value: 'All' }];

    permissionFilters = [{ label: 'All', value: 'All' }];

    @Output() closed = new EventEmitter<boolean>();
    constructor(
        private service: EmployeeService,
        private impersonationService: ImpersonationService,

        private userManagementService: UserManagementService,
        private currentUserStateService: CurrentUserStateService
    ) {}

    ngOnInit() {
        this.getData();
    }

    closeDialog() {
        this.closed.emit(true);
    }

    setUser() {
        let impersonatedEmail = this.selectedUser.loginEmail;
        this.userManagementService.impersonationStart(impersonatedEmail, this.selectedUser.lfName);

        this.closeDialog();
    }

    getData() {
        let shortName = this.impersonationService.isImpersonatingClient()
            ? this.impersonationService.impersonateClient
            : this.currentUserStateService.currentUser.clientShortName;

        this.service.getAllUserEmployeesForClient(shortName).subscribe((users) => {
            if (!this.currentUserStateService.isLBASuperUser()) {
                this.data = users.filter((user) => !user.isClientPowerUser);
            } else {
                this.data = users;
            }

            this.data = this.data.filter((x) => x.isActive == null || x.isActive == true);

            // Set role filters
            const uniqueRoleNames = Array.from(new Set(this.data.map((item) => item.roleName)))
                .map((roleName) => ({
                    label: roleName,
                    value: roleName,
                }))
                .sort((a, b) => a.label.localeCompare(b.label));

            this.roleFilters.push(...uniqueRoleNames);

            // Set permission filters
            const uniquePermissionNames = Array.from(
                new Set(
                    this.data
                        .filter((x) => x.permissionSetName !== null)
                        .map((item) => item.permissionSetName)
                )
            )
                .map((permissionSetName) => ({
                    label: permissionSetName,
                    value: permissionSetName,
                }))
                .sort((a, b) => a.label.localeCompare(b.label));

            this.permissionFilters.push(...uniquePermissionNames);

            // Set position filters
            const uniquePositionNames = Array.from(
                new Set(this.data.map((item) => item.positionName))
            )
                .map((positionName) => ({
                    label: positionName,
                    value: positionName,
                }))
                .sort((a, b) => a.label.localeCompare(b.label));

            this.positionFilters.push(...uniquePositionNames);

            this.visibleData = [...this.data];
        });
    }

    updateFilters() {
        this.visibleData = [...this.data];

        if (this.roleFilter !== 'All') {
            this.visibleData = this.visibleData.filter((x) => x.roleName === this.roleFilter);
        }

        if (this.positionFilter !== 'All') {
            this.visibleData = this.visibleData.filter(
                (x) => x.positionName === this.positionFilter
            );
        }

        if (this.permissionFilter !== 'All') {
            this.visibleData = this.visibleData.filter(
                (x) => x.permissionSetName === this.permissionFilter
            );
        }
    }
}
